import React, { FC } from 'react';
import { TypeReplacementPartsFields } from '@/core/generated-types';
import { TypeReplacementPartsProductsPageData } from '@/app/[locale]/(shop)/account/replacement-parts/fetchPageData';
import { TypeReplacementPartsComponentsPageData } from '@/app/[locale]/(shop)/account/replacement-parts/[product]/fetchPageData';
import { TypeReplacementPartsSubcomponentsPageData } from '@/app/[locale]/(shop)/account/replacement-parts/[product]/[component]/fetchPageData';
import { CONTENT_TYPE_REPLACEMENT_PARTS } from '@/core/constants';
import ReplacementPartsProducts from './ReplacementPartsProducts';
import ReplacementPartsComponents from './ReplacementPartsComponents';
import ReplacementPartsSubcomponents from './ReplacementPartsSubcomponents';

interface ReplacementPartsProps extends TypeReplacementPartsFields {
  data: TypeReplacementPartsProductsPageData &
    TypeReplacementPartsComponentsPageData &
    TypeReplacementPartsSubcomponentsPageData;
}

const ReplacementParts: FC<ReplacementPartsProps> = (props) => {
  const VERSION_MAP = {
    // account/replacement-parts
    [CONTENT_TYPE_REPLACEMENT_PARTS.PRODUCTS]: (
      <ReplacementPartsProducts {...props} />
    ),
    // account/replacement-parts/[component]
    [CONTENT_TYPE_REPLACEMENT_PARTS.COMPONENTS]: (
      <ReplacementPartsComponents {...props} />
    ),
    // account/replacement-parts/[component]/[subcomponents]
    [CONTENT_TYPE_REPLACEMENT_PARTS.SUBCOMPONENTS]: (
      <ReplacementPartsSubcomponents {...props} />
    ),
  };

  return (
    <section
      data-testid="replacement-parts"
      className="mx-auto max-w-[1128px] p-6"
    >
      {VERSION_MAP[props.version]}
    </section>
  );
};

export default React.memo(ReplacementParts);
